import api from '../axiosConfig';
import { ROLES } from '../config/apiEndpoints';

export const PermissionService = {
    getAll: async (params = {}) => {
        try {
            const response = await api.get(ROLES.PERMISSIONS_MATRIX);
            const data = response.data;
            return data.data || data;
        } catch (error) {
            console.error('PermissionService getAll error:', error);
            throw error;
        }
    },

    save: async (permission) => {
        console.log('Permission changed:', permission);
    },

    delete: async (id) => {
        console.log('Revoking permission:', id);
    },

    updateMatrix: async (payload, tenantId) => {
        try {
            const response = await api.put(ROLES.PERMISSIONS_MATRIX, payload, {
                headers: { 'x-tenant-id': tenantId }
            });
            return response.data;
        } catch (error) {
            console.error('PermissionService updateMatrix error:', error);
            throw error;
        }
    },
};
